import { OrderTypes } from "@dana/Handlers/ProductAvailabilityHandler";
import {
    addToChainAfter,
} from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/Cart/Handlers/AddWishListToCart";
import { getCookie } from "@insite/mobius/utilities/cookies";


// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}
// trying to reference a handler not in the chain will result in a warning and the chain will not be modified
addToChainAfter(
    chain,
    PopulateApiParameter,
    props => {

        const orderType = getCookie('modalOrderType');
        if (orderType === OrderTypes.EMERGENCY) {
            props.apiParameter.additionalQueryStringParameters = {
                "IsEmergencyOrder": true
            }
        }
        if (orderType === OrderTypes.ANNUALRETURNS) {
            props.apiParameter.additionalQueryStringParameters = {
                "IsAnnualReturnsOrder": true
            }
        }
    },
);
